<template>
  <div class="about__main">

    <section class="about__main__section">
      <img class="about__main__section__image" src="@/assets/img/about/main/geberit-frame.png" alt="about" />
      <div class="about__main__section__text">
        <h2 class="about__main__section__heading">
          Co to jest <br />
          program Geberit Pro?
        </h2>
        <p>
          Geberit Pro to program wspierający codzienną pracę Instalatorów. Oferujemy korzyści, usługi oraz nagrody
          wspierające Twój biznes.
        </p>
        <p>
          Jako Partner naszego programu masz szansę dołączenia do wąskiej grupy specjalistów i wymiany doświadczeń z
          najlepszymi Instalatorami. Poprzez udział w szkoleniach i innych wydarzeniach branżowych, narzędzia
          internetowe i portale społecznościowe pozostaniesz w bliskim kontakcie z profesjonalistami zyskując wsparcie
          techniczne i produktowe.
        </p>
      </div>
    </section>

    <section class="about__main__section">
      <img class="about__main__section__image" src="@/assets/img/about/main/geberit-installer.png" alt="about" />
      <div class="about__main__section__text">
        <h2 class="about__main__section__heading">
          Dla kogo jest <br />
          program Geberit Pro?
        </h2>
        <p>
          Program Geberit Pro kierowany jest do wszystkich Instalatorów, Hydraulików, Płytkarzy oraz Wykończeniowców
          łazienek prowadzących swój biznes i na co dzień pracujących na produktach Geberit.
        </p>
        <p>
          Wystarczy że regularnie dokonujesz zakupów Geberit w hurtowniach instalacyjnych lub sklepach sanitarnych.
          Zarejestruj się na stronie internetowej, przesyłaj faktury lub raporty z obrotami i odbieraj nagrody.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Main'
}
</script>



// WEBPACK FOOTER //
// src/app/about/Main.vue